<template>
  <div>
    <!--<Row :gutter="16">-->
      <!--<Col :lg="4" style="padding: 5px">-->
        <!--<JenkinsMain ref="JenkinsMain"></JenkinsMain>-->
      <!--</Col>-->
    <!--</Row>-->
    <JenkinsEdit ref="JenkinsEdit" v-on:editComplete="editComplete"></JenkinsEdit>
    <Card shadow>
      <Row class="sm-pc-w100">
        <Col :md="22">
          <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
            <FormItem label="名称">
              <Input v-model="tableSearchForm.name" style="width: 200px" @on-enter="getTableData()" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="2" class="align-right">
          <Button
            style="float: right;"
            @click="edit()"
            type="primary"
            :style="{marginBottom: '10px'}"
            v-if="$store.state.user.superuser"
            icon="md-add">添加Jenkins</Button>
        </Col>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        stripe
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getJenkins, deleteJenkins } from '@/api/tools/jenkins'
import JenkinsEdit from './components/edit'
import moment from 'moment'

export default {
  components: {
    JenkinsEdit
  },
  data () {
    return {
      tableLoading: false,
      tableSearchForm: {
        name: ''
      },
      table: {
        data: [],
        columns: [
          {
            title: '名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: 'URL',
            key: 'url',
            align: 'center',
            tooltip: true,
            minWidth: 250
          },
          {
            title: '用户名',
            key: 'username',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '所属租户',
            key: 'tenant_name',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '创建用户',
            key: 'created_user',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.created_user.name ? params.row.created_user.name : params.row.created_user.username)
            }
          },
          {
            title: '创建时间',
            key: 'created_at',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.created_at) {
                return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 200,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'jenkins_detail', params: { id: params.row.id }})
                    }
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.jenkins_action_permission ? 'inline-block' : 'none'
                  },
                  on: {
                    click: () => {
                      this.edit(params.row.id)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: params.row.jenkins_action_permission ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      listError: false
    }
  },
  created: function () {
    this.getTableData()
  },
  methods: {
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      getJenkins(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    edit (id) {
      this.$refs.JenkinsEdit.openModal(id)
    },
    delete (row) {
      deleteJenkins(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: ''
      }
    },
    // 编辑完成
    editComplete (isUpdate) {
      if (isUpdate) {
        this.getTableData()
      } else {
        this.getTableData(this.table.page)
      }
    }
  }
}
</script>

<style scoped>

</style>
